// Utils
import { get } from "Utils/HTTPMethods";

export const validateMbsSsoDomain = async (domain) =>
  get("QBookingResource", "/mbsValidateSsoDomain", { domain });
